import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    output,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FilledIconPipe } from '@interacta-shared/ui';
import { IconComponent } from '@interacta-shared/ui-icons';
import { CoreDiscoveryService } from '@modules/core/services/core-discovery.service';
import { SidebarSection } from '@modules/sidebar/models/sidebar.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-sidebar-section',
    templateUrl: './sidebar-section.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgClass,
        NgTemplateOutlet,
        IconComponent,
        MatTooltip,
        RouterModule,
        TranslatePipe,
        FilledIconPipe,
    ],
})
export class SidebarSectionComponent {
    private discoveryService = inject(CoreDiscoveryService);

    readonly section = input.required<SidebarSection>();
    readonly selected = input(false);
    readonly advancedSidebar = input(false);
    readonly advancedSidebarOpen = input(false);
    readonly advancedSidebarControlsId = input<string>();
    readonly expanded = input(true);
    readonly disabled = input(false);
    readonly id = input<string>();

    readonly toggleAdvancedSidebar = output<void>();

    readonly newSection = computed(() => {
        if (this.selected()) {
            return false;
        } else {
            return this.discoveryService
                .getNewSectionIds()
                .includes(this.section().id);
        }
    });

    selectSection(section: SidebarSection): void {
        if (section.hidden) return;

        this.toggleAdvancedSidebar.emit();
    }
}
